/**
 * arbi tui [--workspace <id>]
 *
 * Launches the interactive terminal UI (@arbidocs/tui).
 * The TUI package is a direct dependency, so it's always available.
 */

import { Command } from 'commander'
import { spawn } from 'node:child_process'
import { createRequire } from 'node:module'

export function registerTuiCommand(program: Command): void {
  program
    .command('tui')
    .description('Launch interactive terminal UI')
    .option('-w, --workspace <id>', 'Workspace ID to use')
    .allowUnknownOption(true)
    .action((opts: { workspace?: string }, cmd: Command) => {
      const require = createRequire(import.meta.url)
      const entryPoint = require.resolve('@arbidocs/tui')

      const args: string[] = []
      if (opts.workspace) {
        args.push('-w', opts.workspace)
      }
      args.push(...cmd.args)

      const child = spawn(process.execPath, [entryPoint, ...args], {
        stdio: 'inherit',
        env: process.env,
      })

      child.on('exit', (code) => process.exit(code ?? 0))
    })
}
